var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import MapDot from './MapDot.vue';
let ProjectMap = class ProjectMap extends Vue {
    constructor() {
        super(...arguments);
        this.isClickable = true;
        this.zoom = 1;
        this.isDragging = false;
        this.positions = {
            x: 0,
            y: 0,
            clientX: undefined,
            clientY: undefined,
            movementX: 0,
            movementY: 0
        };
    }
    created() {
        if (this.clickable != undefined) {
            this.isClickable = this.clickable;
        }
    }
    onClick(_id) {
        this.$emit('onClick', _id);
    }
    onClickWithFocus(_id) {
        this.$emit('onClickWithFocus', _id);
    }
    zoomIn() {
        if (this.zoom < 10) {
            this.zoom += .5;
        }
    }
    zoomOut() {
        if (this.zoom > 1) {
            this.zoom -= .5;
        }
    }
    dragMouseDown(event) {
        if (!this.clickable)
            return;
        event.preventDefault();
        this.isDragging = true;
        // get the mouse cursor position at startup:
        this.positions.clientX = event.clientX;
        this.positions.clientY = event.clientY;
        document.onmousemove = this.elementDrag;
        document.onmouseup = this.closeDragElement;
    }
    elementDrag(event) {
        event.preventDefault();
        this.positions.movementX = this.positions.clientX - event.clientX;
        this.positions.movementY = this.positions.clientY - event.clientY;
        this.positions.clientX = event.clientX;
        this.positions.clientY = event.clientY;
        this.positions.x -= this.positions.movementX / this.zoom;
        this.positions.y -= this.positions.movementY / this.zoom;
    }
    closeDragElement() {
        this.isDragging = false;
        document.onmouseup = null;
        document.onmousemove = null;
    }
};
__decorate([
    Prop()
], ProjectMap.prototype, "projects", void 0);
__decorate([
    Prop()
], ProjectMap.prototype, "activeId", void 0);
__decorate([
    Prop({
        default: false
    })
], ProjectMap.prototype, "active", void 0);
__decorate([
    Prop()
], ProjectMap.prototype, "clickable", void 0);
__decorate([
    Prop()
], ProjectMap.prototype, "zoomable", void 0);
__decorate([
    Prop({ default: 8 })
], ProjectMap.prototype, "dotSize", void 0);
__decorate([
    Prop({ default: 686 })
], ProjectMap.prototype, "initialWidth", void 0);
__decorate([
    Prop({ type: Object })
], ProjectMap.prototype, "labels", void 0);
__decorate([
    Prop()
], ProjectMap.prototype, "fontsize", void 0);
ProjectMap = __decorate([
    Component({
        components: {
            MapDot
        }
    })
], ProjectMap);
export default ProjectMap;
